export class BaseActivity {
  public Info: string;
  public Data: string;
  public DateStamp: Date;
}
